export default (email: string): boolean => {
  email = (email || '').toLowerCase();
  return /^\w+([.(-|+)]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
};
